import { render, staticRenderFns } from "./TableRow.vue?vue&type=template&id=b6c75b34&scoped=true&"
import script from "./TableRow.vue?vue&type=script&lang=js&"
export * from "./TableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c75b34",
  null
  
)

/* custom blocks */
import block0 from "./TableRow.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6c75b34')) {
      api.createRecord('b6c75b34', component.options)
    } else {
      api.reload('b6c75b34', component.options)
    }
    module.hot.accept("./TableRow.vue?vue&type=template&id=b6c75b34&scoped=true&", function () {
      api.rerender('b6c75b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Layout/TableRow.vue"
export default component.exports